import I18n from "i18n-js";
import React from "react";

export default class UserLearningPlans extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      course_image_errors: {},
    };
  }

  render() {
    return (
      <div className="user-learning-plans">
        {this.props.user_learning_plans.map((user_learning_plan) =>
          this.renderLearningPlan(user_learning_plan)
        )}
      </div>
    );
  }

  renderLearningPlan(user_learning_plan) {
    const {
      learning_plan = {},
      is_complete = false,
      is_completion_certificate_enabled = false,
      download_learning_plan_completion_certificate_path = "#",
    } = user_learning_plan;
    const { learning_plan_sections = [] } = learning_plan;
    const [learning_plan_section] = learning_plan_sections;
    const { learning_plan_items = [] } = learning_plan_section;

    return (
      <div className="learning-plan" key={user_learning_plan.id}>
        <div className="learning-plan-heading">
          <span className="learning-plan-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="1em"
              viewBox="0 0 512 512"
            >
              <path
                fill="rgba(255, 255, 255, 0.35);"
                d="M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
              />
            </svg>
          </span>
          <div className="learning-plan-name">{learning_plan.name}</div>
          {is_complete ? (
            <div className="learning-plan-complete">
              {this.renderCompleteIcon(false)}
              {is_completion_certificate_enabled ? (
                <a href={download_learning_plan_completion_certificate_path}>
                  {I18n.t("download_certificate")}
                </a>
              ) : null}
            </div>
          ) : null}
        </div>
        <div className="learning-plan-items">
          {learning_plan_items.map((learning_plan_item) =>
            this.renderLearningPlanItem(learning_plan, learning_plan_item)
          )}
        </div>
      </div>
    );
  }

  renderLearningPlanItem(learning_plan, learning_plan_item) {
    if (learning_plan_item.learnable_type === "Course") {
      return this.renderCourse(learning_plan, learning_plan_item);
    } else if (learning_plan_item.learnable_type === "Exam") {
      return this.renderExam(learning_plan, learning_plan_item);
    }
  }

  renderLearningPlanItemIcon(learning_plan_item) {
    if (learning_plan_item.learnable_type === "Course") {
      return <i className="fa fa-book learning-plan-item-icon" />;
    } else if (learning_plan_item.learnable_type === "Exam") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="1em"
          viewBox="0 0 448 512"
        >
          <path d="M64 80c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V96c0-8.8-7.2-16-16-16H64zM0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" />
        </svg>
      );
    }
  }

  renderCompleteIcon(showCompleteBullet = true) {
    return (
      <div className="CompleteIconWrapper">
        {showCompleteBullet ? <div className="CompleteBullet" /> : null}
        <div className="CompleteIcon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi bi-check"
            viewBox="0 0 16 16"
          >
            {" "}
            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
          </svg>
        </div>
        <span className="CompleteLabel">{I18n.t("complete")}</span>
      </div>
    );
  }

  renderCourse(learning_plan, learning_plan_item) {
    const { sequential } = learning_plan;
    const {
      id,
      learnable = {},
      is_complete,
      is_disabled,
      progress,
      path,
      posttest = false,
      pretest_user_assessment,
      posttest_user_assessment,
      has_passing_posttest,
    } = learning_plan_item;
    const calculated_progress = Math.floor(progress * 100);
    const { name, image_url } = learnable;

    return (
      <div
        className={
          "learning-plan-item " +
          (sequential && is_disabled ? "learning-plan-item-disabled " : "")
        }
        key={id}
      >
        <div className="learning-plan-image">
          <div className="image">
            {this.state.course_image_errors.hasOwnProperty(id) ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1em"
                viewBox="0 0 512 512"
              >
                <path d="M160 96a96 96 0 1 1 192 0A96 96 0 1 1 160 96zm80 152V512l-48.4-24.2c-20.9-10.4-43.5-17-66.8-19.3l-96-9.6C12.5 457.2 0 443.5 0 427V224c0-17.7 14.3-32 32-32H62.3c63.6 0 125.6 19.6 177.7 56zm32 264V248c52.1-36.4 114.1-56 177.7-56H480c17.7 0 32 14.3 32 32V427c0 16.4-12.5 30.2-28.8 31.8l-96 9.6c-23.2 2.3-45.9 8.9-66.8 19.3L272 512z" />
              </svg>
            ) : (
              <img
                src={image_url}
                onError={this.onCourseImageError.bind(this, learning_plan_item)}
              />
            )}
          </div>
        </div>
        <div className="learning-plan-item-name-and-progress">
          <div className="learning-plan-item-name">{name}</div>
          <div className="learning-plan-item-progress">
            {calculated_progress == 0 ? (
              <div className="learning-plan-label">
                {I18n.t("ready_to_get_started")}
              </div>
            ) : (
              <div className="learning-plan-progress-wrapper learning-plan-content-progress">
                <span className="learning-plan-label">
                  {I18n.t("content_progress")}
                </span>
                {calculated_progress == 100 ? (
                  this.renderCompleteIcon()
                ) : (
                  <progress max="100" value={calculated_progress}>
                    {calculated_progress}%
                  </progress>
                )}
              </div>
            )}
          </div>
          <div
            className="learning-plan-item-progress"
            style={{ marginTop: "5px" }}
          >
            {this.renderTestScores(
              pretest_user_assessment,
              posttest_user_assessment,
              learning_plan_item,
              calculated_progress
            )}
          </div>
        </div>
        {this.renderCourseButton(
          sequential,
          is_disabled,
          is_complete,
          path,
          progress
        )}
      </div>
    );
  }

  renderTestScores(
    pretest_user_assessment,
    posttest_user_assessment,
    learning_plan_item,
    calculated_progress
  ) {
    return (
      <div className="learning-plan-item-progress">
        {this.renderTestScore(pretest_user_assessment, "pretest")}

        {pretest_user_assessment && posttest_user_assessment ? (
          <span className="CompleteIconWrapper">
            <span className="CompleteBullet" />
          </span>
        ) : null}

        {this.renderTestScore(posttest_user_assessment, "posttest")}

        {learning_plan_item.posttest && calculated_progress === 100 ? (
          <span
            className="CompleteIconWrapper"
            style={{
              marginLeft:
                pretest_user_assessment || posttest_user_assessment
                  ? "6px"
                  : "0",
            }}
          >
            {pretest_user_assessment || posttest_user_assessment ? (
              <span className="CompleteBullet" />
            ) : null}
            {this.renderTakePostTestLink(learning_plan_item)}
          </span>
        ) : null}
      </div>
    );
  }

  renderTestScore(user_assessment, test_type) {
    if (user_assessment && test_type) {
      return (
        <span className="learning-plan-label learning-plan-test-score">
          {I18n.t(test_type)} {user_assessment.score}%
        </span>
      );
    }
  }

  renderTakePostTestLink(learning_plan_item) {
    if (learning_plan_item) {
      return (
        <span className="learning-plan-label">
          <a
            href={learning_plan_item.take_posttest_path}
            style={{ textDecoration: "underline" }}
          >
            {I18n.t("take_posttest")}
          </a>
        </span>
      );
    }
  }

  renderCourseButton(sequential, is_disabled, is_complete, path, progress) {
    if (sequential && is_disabled) {
      return (
        <div className="learning-plan-item-actions">
          <a href="#" disabled className="btn btn-primary btn-disabled">
            {I18n.t("locked")}
          </a>
        </div>
      );
    } else if (!is_complete) {
      return (
        <div className="learning-plan-item-actions">
          <a href={path} className="btn btn-primary">
            {progress ? I18n.t("continue") : I18n.t("start")}
          </a>
        </div>
      );
    } else if (is_complete) {
      return (
        <div className="learning-plan-item-actions">
          <a href={path} className="btn btn-primary btn-outline btn-completed">
            {I18n.t("completed")}
          </a>
        </div>
      );
    } else {
      return (
        <div className="learning-plan-item-actions">
          <a href={path} className="btn btn-primary btn-outline">
            {I18n.t("continue")}
          </a>
        </div>
      );
    }
  }

  renderExam(learning_plan, learning_plan_item) {
    const { sequential } = learning_plan;
    const {
      id,
      learnable = {},
      is_complete,
      is_disabled,
      path,
    } = learning_plan_item;
    var { user_assessments = [] } = learning_plan_item;
    const { name } = learnable;
    const icon = this.renderLearningPlanItemIcon(learning_plan_item);
    user_assessments = user_assessments.filter(
      (user_assessment) => user_assessment.completed
    );
    var user_assessment = null;
    if (user_assessments.length) {
      for (var i = 0, ilen = user_assessments.length; i < ilen; i++) {
        if (user_assessments[i].completed) {
          user_assessment = user_assessments[i];
          break;
        }
      }
    }

    const { completed = false } = user_assessment || {};

    return (
      <div
        className={
          "learning-plan-item " +
          (sequential && is_disabled ? "learning-plan-item-disabled " : "")
        }
        key={id}
      >
        <div className="learning-plan-image">
          <div className="image">{icon}</div>
        </div>
        <div className="learning-plan-item-name-and-progress">
          <div className="learning-plan-item-name">{name}</div>
          {completed ? (
            <div className="learning-plan-item-progress">
              <span className="learning-plan-label  learning-plan-score">
                {user_assessment && user_assessment.score_released ? (
                  <div>{user_assessment.score}%</div>
                ) : null}
              </span>
              {user_assessment ? (
                <div className="learning-plan-progress-wrapper learning-plan-score">
                  {this.renderCompleteIcon(user_assessment.score_released)}
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
        {this.renderExamButton(sequential, is_disabled, is_complete, path)}
      </div>
    );
  }

  renderExamButton(sequential, is_disabled, is_complete, path) {
    if (sequential && is_disabled) {
      return (
        <div className="learning-plan-item-actions">
          <a href="#" disabled className="btn btn-primary btn-disabled">
            {I18n.t("locked")}
          </a>
        </div>
      );
    } else if (!is_complete) {
      return (
        <div className="learning-plan-item-actions">
          <a href={path} className="btn btn-primary">
            {I18n.t("take")}
          </a>
        </div>
      );
    } else {
      return (
        <div className="learning-plan-item-actions">
          <a href={path} className="btn btn-primary btn-outline">
            {I18n.t("retake")}
          </a>
        </div>
      );
    }
  }

  onCourseImageError(learning_plan_item) {
    const { course_image_errors } = this.state;
    course_image_errors[learning_plan_item.id] = true;
    this.setState({ course_image_errors: course_image_errors });
  }
}
